import React, { FC, MouseEvent, ReactNode, useContext } from 'react'

import { Screener } from '@hhgtech/icons/other'
import { Box, BoxProps } from '@mantine/core'
import flattenChildren from 'react-keyed-flatten-children'

import { CarePathDefaultContext } from 'components/templates/carePath/landing/context'
import { MapIcons } from 'components/templates/carePath/landing/icons'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { useHandlerUrls } from 'hooks/useHandlerUrls'
import { ScrollToItemType, SessionType } from 'interfaces/types'

import { BlockItemPropsType } from './blockItem'
import useStyles from './index.styles'

export type NavigatorProps = {
  colorArr: string[]
  navigating: ScrollToItemType[]
  itemProps?: Partial<BlockItemPropsType>
  children?: ReactNode[]
  iconSize?: number
  selectedSection?: string
  isDropdown?: boolean
  dataActionBySession?: { [key in SessionType]?: string }
  mappingIconList: MapIcons
  itemComponent?: FC<BlockItemPropsType>
  hideIcon?: boolean
  isApp?: boolean
  logo?: {
    icon: string
    url: string
  }
  onNavClick: (
    i: ScrollToItemType,
    e?: MouseEvent<HTMLDivElement | HTMLAnchorElement>,
  ) => void
} & BoxProps

export const HERO_BANNER_ID_SCROLL = 'heroBanner'
export const HERO_BANNER_SESSION_LAYOUT_LISTS = [
  SessionType.HERO_BANNER_DEFAULT,
  SessionType.HERO_BANNER_FULLWIDTH,
  SessionType.HERO_BANNER_APP,
]

const Navigator = ({
  // navigating = [],
  className,
  classNames,
  styles,
  itemProps,
  children,
  iconSize,
  dataActionBySession,
  // colorArr,
  selectedSection,
  isDropdown,
  // mappingIconList,
  itemComponent,
  onNavClick,
  ...boxProps
}: any) => {
  const { classes, cx } = useStyles(undefined, {
    name: 'CarePathHeroBannerNavigator',
    classNames,
    styles,
  })
  const {
    colorArr,
    navigating = [],
    // selectedSection,
    mappingIconList,
  } = useContext(CarePathDefaultContext)
  const currentUrl = useCurrentUrl()
  const linkData = useHandlerUrls(navigating.map((i: any) => i.url))
  const linkDataByIdScroll: any = {}
  navigating.map((i: any, idx: number) => {
    linkDataByIdScroll[i.idScroll] = linkData[idx]
  })

  return navigating.length > 0 ? (
    <Box className={cx(classes.root, className)} {...boxProps}>
      {flattenChildren(children).map(
        // (element: ReactElement<BlockItemPropsType>, idx) => {
        (element: any, idx) => {
          const i = navigating[idx]
          return i
            ? React.cloneElement(element, {
                component: 'a',
                href: i.url || `#${i.idScroll}`,
                key: String(idx),
                item: i,
                displayAs: itemComponent,
                isSelected: HERO_BANNER_SESSION_LAYOUT_LISTS.includes(
                  i.sessionLayout,
                )
                  ? selectedSection === HERO_BANNER_ID_SCROLL
                  : selectedSection === i.idScroll,
                icon: i.image ? (
                  <img src={i.image} alt={i.title} loading="eager" />
                ) : (
                  mappingIconList[i.sessionLayout] || <Screener />
                ),
                bgColor: colorArr[idx % 4],
                'data-event-category': 'Service Connection',
                'data-event-action':
                  dataActionBySession?.[i.sessionLayout] || '',
                'data-event-label':
                  i.url ||
                  `${currentUrl.split('#')[0]}${
                    i.idScroll ? '#' + decodeURI(i.idScroll) : ''
                  }`,
                'data-banner-navigate': true,
                className: 'sticky-nav-item pointer-event-child-none',
                ...element.props,
                onClick: (e: MouseEvent<HTMLAnchorElement>) => {
                  onNavClick?.(i, e)
                  element.props?.onClick?.(i)
                },
              })
            : null
        },
      )}
    </Box>
  ) : null
}

export { Navigator }
